import { fixedCourseLabel } from 'src/components/dispatch/courseDiff';

import type { CourseDiffEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 運行指示書の「元: 101-3」（log_web_issues#353、D4 ルール 7: 運行指示書は移動先だけ）。
 * 明細行（DirectionRow）の origin に持ち、合算（mergeBySameRow）と行結合（buildCellSpans）の同値判定に効かせる。
 */

/** コース変更の明細だけ。配送順変更・変更なしは出さない */
export function originLabelOf(diff: CourseDiffEntity | null | undefined): string | null {
  return diff?.kind === 'course_changed' ? `元: ${fixedCourseLabel(diff)}` : null;
}

/** 「元」を添える列。作業場所 → 降地 → 先頭の列（表示列の設定で作業場所が無い会社でも消えない） */
export function originHostColumn(headers: readonly string[]): string | null {
  if (headers.includes('作業場所')) return '作業場所';
  if (headers.includes('降地')) return '降地';
  return headers[0] ?? null;
}
